import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CustomFieldService } from '@app/core';
import { CustomField } from '@app/shared';


@Component({
    selector: 'app-custom-field-list',
    templateUrl: './custom-field-list.component.html',
    styleUrls: ['./custom-field-list.component.css']
})
export class CustomFieldListComponent implements OnInit {

    private _showActive = true;
    private _loading = false;
    private _fields: CustomField[] = [];

    private readonly typeLabels: { [key: string]: string } = {
        text: 'Tekst',
        textarea: 'Langt tekstfelt',
        radio: 'Valg – én mulighed',
        checkbox: 'Valg – flere muligheder'
    };

    constructor(
        private customFieldService: CustomFieldService,
        private router: Router
    ) { }

    typeLabel(fieldType: string) {
        return this.typeLabels[fieldType] || fieldType;
    }

    get fields() {
        return this._fields;
    }

    get isLoading() {
        return this._loading;
    }

    get showActive() {
        return this._showActive;
    }

    ngOnInit() {
        this.getFields();
    }

    editField(field: CustomField) {
        this.router.navigate(['/admin/custom-field', field.id]);
    }

    toggleActive() {
        this._showActive = !this._showActive;
        this.getFields();
    }

    private getFields() {
        this._loading = true;
        this.clear();
        this.customFieldService.list(this._showActive).subscribe(
            field => this._fields.push(field),
            error => console.error('Error getting custom field list'),
            () => {
                this._loading = false;
            }
        );
    }

    private clear() {
        this._fields.length = 0;
    }

}
